import React from 'react';
import { Row, Card } from 'react-bootstrap';
import NumberBoxList from './NumberBoxList';
import FarmGraph from './FarmGraph';

const SummaryWrapper = () => {
    return <Card.Body className="worked-details-body">
        <Row className="widget-card-list">
            <NumberBoxList />
        </Row>
        <Row className="area-spline-graph" id="farm-analyse-area-spline-graph">
            <FarmGraph />
        </Row>
    </Card.Body >
}

export default SummaryWrapper;